import React from 'react';

const Comentarios = ({ selectedVisita, setSelectedVisita }) => {
  return (
    <div className="w-full">
      <label className="block mb-1 text-xs font-medium text-gray-700 truncate">Comentarios</label>
      <textarea
        className="truncatecomentarios shadow-sm w-full p-2 border rounded bg-white mb-0 resize-y min-h-[120px] text-sm" 
        rows={9}
        value={selectedVisita?.Comentarios || ''}
        onChange={(e) => setSelectedVisita({ ...selectedVisita, Comentarios: e.target.value })}
      />
    </div>
  );
};

export default Comentarios;
